module.exports = __webpack_public_path__ + "img/shhy.9e7dac60.jpg";